import Vue from 'vue'
import axios from "axios"
import router from '../router/index.js'
import {
  Message
} from "element-ui";
const HttpRequest = {
  getRequest({
    url,
    data = {},
    method = "GET",
    isParams,
    unLogin,
  }) {
    return new Promise((resolve, reject) => {
      this._getRequest(url, resolve, reject, data, method, isParams, unLogin);
    });
  },
  _getRequest: function (url, resolve, reject, data = {}, method = "GET", isParams = false, unLogin = false) {

    let format

    if (isParams) {
      format = 'params'
    } else {
      format = method.toLocaleLowerCase() === 'get' ? 'params' : 'data';
    }
    axios({
      url: process.env.API_ROOT + url,
      method: method,
      [format]: data,
      headers: {
        "Authorization": "Bearer " + window.localStorage.getItem('token'),
        "content-type": "application/json"
      }
    }).then(res => {
      if (res.status == 200) {
        resolve(res.data);
      } else if (res.code == -1) {
        resolve(res.data);
      }
    }).catch((err) => {
      if (err.response.status === 401 && !unLogin) {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem('headImage');
        router.push({
          path: '/account/login'
        })
        Message({
          message: '请登录后重试!',
          type: 'error',
          duration: 5000
        });
      } else {
        reject(err.response.data);
      }
    })
  }
};
export {
  HttpRequest
};



// WEBPACK FOOTER //
// ./src/utils/request.js